import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-apollo-hooks'
import * as Queries from './queries'
import cookie from 'js-cookie'
import { LinkWithRoundIcon, ga, constants } from '../../application'
import getText from '../strings'
import styled from 'react-emotion'

const Container = styled('div')`
  flex-grow: 1;
  span {
    opacity: 0.5;
    font-size: 0.8em;
  }
  a {
      margin-top: 4px;
  }
`

const getAncillaryIcon = (code) => {
    switch (code) {
        case 'meal':
            return 'eat'
        case 'seating':
        case 'premium_seat':
            return 'seat'
        case 'transfer':
            return 'bus'
        case 'luggage':
        case 'baggage':
        case 'extra_luggage':
            return 'luggage'
        case 'child_products':
            return 'teddy'
        default:
            return 'plus'
    }
}

export default ({ bookingNumber, isAtcomBooking }) => {
    const { loading, data } = useQuery(Queries.getRecommendations(bookingNumber))
    const { loading: tokenLoading, data: tokenData } = isAtcomBooking
        ? { data: { myHolidayToken: { token: null } } }
        : useQuery(Queries.getMyHolidayToken(bookingNumber))

    const [token, setToken] = useState(null)
    const [ancillaries, setAncillaries] = useState([])

    useEffect(() => {
        if (!tokenLoading && tokenData.myHolidayToken && tokenData.myHolidayToken.token) {
            setToken(tokenData.myHolidayToken.token)
        }
    }, [tokenLoading, tokenData])

    useEffect(() => {
        if (!loading && data.ancillaryRecommendations) {
            const mappedAncillaries = data.ancillaryRecommendations.map(a => {
                trackItem(a.isControlGroup, 'display', a.type)
                return {
                    code: a.type,
                    icon: getAncillaryIcon(a.type),
                    text: a.short_title,
                    action: () => handleAncillaryClick({
                        type: a.type,
                        bookingNumber,
                        link: a.url,
                    })
                }
            })

            setAncillaries(mappedAncillaries.slice(0, Math.min(3, mappedAncillaries.length)))
        }
    }, [loading, data])

    const handleAncillaryClick = (data) => {
        trackItem(data.isControlGroup, 'click', data.type)
        cookie.set(constants.MYHOLIDAY_SESSION_JWT, token)
        window.location.href = data.link
    }

    const trackItem = (isControlGroup, action, type) => {
        ga.push({
            event: 'myTuiRecommendations',
            myTuiData: {
                control: isControlGroup,
                action: action,
                value: isControlGroup ? '' : type,
                bookingNumber: bookingNumber
            }
        })
    }

    return (
        <Container>
          {ancillaries.length !== 0 ?
            <>
              <span className="recommended-ancillaries-title">
                {getText("RecommendedAncillaries", "recommedationForYou")}
              </span>
              <div>
                {ancillaries.map(mappedAncillary => (
                  <LinkWithRoundIcon
                    key={mappedAncillary.code}
                    action={mappedAncillary.action}
                    icon={mappedAncillary.icon}
                    text={mappedAncillary.text}
                  />
                ))}
              </div>
            </>
            : null
          }
        </Container>
    )
}